import React from "react";

const shripad_kulkarni = () => {
  return (
    <div>
      <h1>Shripad Kulkarni</h1>

      <h3>
        <em>Computer Engineering, Batch of 27'</em>
        <br />
        <hr />
      </h3>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        There were two stages of shortlisting :<br />
        First was a coding round with 3 medium-hard coding questions, and
        <br />
        Second was hackathon (code for change) in their office for a whole day
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        The overall timeline was around 1 month. The coding round was held a
        week after registration. Around 2–3 days later, the shortlisting for the
        hackathon was announced. The hackathon took place a week after that, and
        finally, the results were declared 10 days later.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        There was no such aptitude round, it was just a coding round with 3
        coding questions.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        12 Students were shortlisted after the coding round.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        After the shortlisting came there was around a week before the
        hackathon. In that time I brushed up my development concepts in MERN. I
        prepared a strategy for the hackathon like looked at the previous year
        problem statements, tried to design the solutions, and also before the
        hackathon, I developed several generic components commonly used in
        full-stack projects — such as an authentication system (login and
        signup) and a messaging service — to be better prepared and save time
        during the event.
        <br />
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        There were no interview rounds during the process. The selection was
        purely based on the coding test and your performance and contribution in
        the hackathon. After coding round - 12, after hackathon - 8.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        The main skills that are required for the hackathon are mainly your
        development skills (could be frontend or backend), designing the
        architecture and flow of the system/solution, time management(very
        important), communication skills and your creativity.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        For DSA - Striver A-Z sheet is a great resource. For core subjects one
        shot videos of love babar, last minute notes from GFG and top interview
        questions are saviours. And for development I would say try building
        some projects in your free time and understand the whole system
        architecture.
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Follow a sheet rather than solving questions randomly. And don't just
        see and try to remember the solutions from the sheet rather first try to
        do the problems by yourself and also understand the patterns.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        None
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        For the hackathon, keep good communication with your teammates and
        especially your mentor. Try to take lead or initiative whenever possible
        and take responsibility that will highlight you. Manage your time very
        properly. And finally be creative wherever you can - your solution and
        especially your presentation(this is very important even if your
        implementation is not completed) that will make a good impression.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        The whole internship process can be stressful, especially when you see
        your friends getting selected by different companies, but you have to
        stay calm, trust your preparation, and keep putting in consistent
        effort.
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Email :</strong> <a href="mailto:shrikulkarni2205@gmail.com">shrikulkarni2205@gmail.com</a>
        <br />
        <strong>LinkedIn :</strong>{" "}
        <a href="https://www.linkedin.com/in/shripad-kulkarni-9a8464248/">Shripad Kulkarni</a>
      </p>

      <hr />
    </div>
  );
};

export default shripad_kulkarni;
